<template>
  <div class='trialCancelledListDialog'>
    <el-dialog 
      v-model="curDialogVisible" 
      center
      :close-on-click-modal="false"
      @closed="escClose">
      <div class="top-title">List of Cancelled Trials</div>
      <el-table 
        class="table"
        ref="dragTable"
        :data="dataList" 
        border
        width="100%"
        fit
        :header-cell-style="{
          background: '#ECF2FE',
          borderColor: '#999999'
        }"
        :cell-style="{
          borderColor: '#999999'
        }"
        v-loading="loading">
        <el-table-column fixed align="center">
          <template #header>
            <div class="header-title">TRAIL</div>
          </template>
          <template #default="scope">
          <div class="trial-bg">
            {{ scope.row.name }}
          </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-bg">
        <div class="page-left">共 {{totalCount }} 项数据</div>
        <el-pagination 
          class="page-right" 
          background 
          layout="prev, pager, next" 
          :total="totalCount" 
          :page-size="pageSie"
          :current-page="currentPage" 
          @current-change="currentDo">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'trialCancelledListDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    allDataList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSie: 8,
    }
  },
  computed: {
    totalCount() {
      return this.allDataList.length
    },
    curDialogVisible() {
      return this.dialogVisible
    },
    dataList() {
      const list = this.allDataList.slice((this.currentPage - 1) * this.pageSie, this.currentPage * this.pageSie)
      return list
    }
  },
  methods: {
    escClose() {
      this.$emit("cancelDo")
    },
    currentDo(index) {
      this.currentPage = index
    },
    cancelDo() {
      this.$emit("cancelDo")
    },
  },
  created() {
  }
}
</script>
<style lang='less' scoped>
.top-title {
  width: 100%;
  color: #000;
  text-align: center;
  font-size: 17px;
  font-weight: bold;
}

 .table {
  width: 100%;
  border: 1px solid #999999;
  margin-top: 20px;
 }

 .header-title {
  height: 45px;
  display:flex;
  align-items: center;
  // justify-content: center;
  padding-left: 20px;
  color: #000000;
  font-size: 16px;
  font-weight: bold;
 }

 .trial-bg {
  display: flex;
  align-items: center;
  padding: 11px 0px 11px 20px;
  color: #0052D9;
    font-size: 15px;
    font-weight: 400;
 }

 .table-other {
  color: #383838;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
 }

 .page-bg {
  display: flex;
  // height: 35px;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px 0px 20px;
  margin-top: 10px;
  .page-left {
    color: #000000;
    font-size: 14px;
    font-weight: 400;
  }
 }

 .btn-box {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  .btn {
    height: 38px;
    width: 160px;
    border-radius: 20px;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn1 {
    background-color: #F5F5F5;
    border: 1px solid #A6A6A6;
    color: #A6A6A6;

  }
  .btn2 {
    background-color: #0052D9;
    border: 1px solid #0052D9;
    color: #ffffff;
  }
 }

:deep(.el-dialog) {
  border-radius: 8px;
  // height: 700px !important;
  padding: 0px 20px 0px 20px; 
  width: 900px !important;
}

//, .el-checkbox__input
:deep(.el-checkbox__input .el-checkbox__input) {
  height: 16px !important;
  width: 16px !important;
}

:deep(.el-table .cell) {
  padding: 0px !important;
}
:deep(.el-table td) {
  padding: 0px !important;
}

:deep(.el-table th) {
  padding: 0px !important;
  user-select: initial !important;
}

:deep(.el-table tr) {
  padding:  0px !important;
}

:deep(.el-button) {
  min-height: 38px !important;
}


</style>